import { toast } from '@tempo-io/sui-sonner';
import { useTranslation } from 'react-i18next';
import type { Item } from '@/common/api/types/items';
import { DeleteDialog } from '@/common/components/delete-dialog';
import { useItemPanelNavigation } from '@/features/item-panel/hooks/useItemPanelParams';
import { useDeleteItemMutation } from '@/features/items/mutations/item/useDeleteItemMutation';
import { useGetItemWorkIntegration } from '@/features/settings/work-integrations/queries/useGetItemWorkIntegration';

export const DeleteItemDialog = ({
  item,
  onOpenChange,
}: {
  item: Item;
  onOpenChange: (open: boolean) => void;
}) => {
  const { t } = useTranslation();
  const { closeItemPanel } = useItemPanelNavigation();
  const deleteItemMutation = useDeleteItemMutation();
  const { isOrphan, isLoading: isWorkIntegrationLoading } = useGetItemWorkIntegration(item);

  return (
    <DeleteDialog
      open
      onOpenChange={onOpenChange}
      isPending={deleteItemMutation.isPending || isWorkIntegrationLoading}
      title={t(($) => $.adaptivePlanner.itemPanel.delete.title)}
      description={
        <p>
          {t(($) => $.adaptivePlanner.itemPanel.delete.description, {
            itemName: item.name,
          })}
        </p>
      }
      cancelLabel={t(($) => $.adaptivePlanner.itemPanel.delete.cancel)}
      confirmLabel={t(($) => $.adaptivePlanner.itemPanel.delete.confirm)}
      onConfirm={() => {
        deleteItemMutation.mutate(
          { itemId: item.id, isOrphanedIntegrationItem: isOrphan },
          {
            onSuccess: () => {
              toast.success(t(($) => $.adaptivePlanner.itemPanel.delete.success));
              onOpenChange(false);
              closeItemPanel();
            },
            onError: () => {
              toast.error(t(($) => $.adaptivePlanner.itemPanel.delete.error));
            },
          },
        );
      }}
    />
  );
};
